import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RowBelow = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 12.793V2a.5.5 0 0 1 1 0v10.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708l2.146 2.147ZM5.5 5a.5.5 0 0 0-1 0v2.5H2a.5.5 0 0 0 0 1h2.5V11a.5.5 0 0 0 1 0V8.5H8a.5.5 0 0 0 0-1H5.5V5Z"
        fill={color}
      />
    </svg>
  )
})

export default RowBelow
